module.exports = __webpack_public_path__ + "media/images/close-d69ca4b257d96a4bb5d41d0c25ffa70c.png";